import React from 'react';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';

const PaginationComponentHorizontalGrid = ({ totalPages, currentPage, setCurrentPage, itemsPerPage, setItemsPerPage }) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.CardGrid[key][currentLang];

  const handleChangePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="pagination-controls flex-h" style={{marginBottom:'10px'}}>
      {/* Previous Page */}
      <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
        {t('Previous')}
      </button>

      {/* Page Numbers */}
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index + 1}
          onClick={() => handleChangePage(index + 1)}
          className={currentPage === index + 1 ? "active" : ""}
        >
          {index + 1}
        </button>
      ))}

      {/* Next Page */}
      <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
        {t('Next')}
      </button>

      {/* Items Per Page Dropdown */}
      <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className='custom-select-simple' style={{ width:'fit-content' }}>
        <option value={5}>5 {t('per page')}</option>
        <option value={10}>10 {t('per page')}</option>
        <option value={15}>15 {t('per page')}</option>
        <option value={20}>20 {t('per page')}</option>
      </select>
    </div>
  );
};

export default PaginationComponentHorizontalGrid;
